export default {
      id: "pay_verify-usage",
      viewBox: "0 0 65 37",
      url: __webpack_public_path__ + "sprite.svg#pay_verify",
      toString: function () {
        return this.url;
      }
    }